import React from "react";

/**
 * Biodeal Animal Health logo asset.
 *
 * Served from /app/frontend/public/ for fast local delivery.
 * This is the original high-detail "Believe in Better" lockup —
 * PNG with full transparency, 2300 × 1524 px, 445 KB. Replaces the
 * previously-used 61 KB compressed JPG which lost detail.
 *
 * The asset contains: the green "Biodeal" wordmark, "Animal Health"
 * green wordmark, green / yellow oval rings, and the "Believe in
 * Better" tagline — all preserved verbatim, never recoloured, never
 * redrawn.
 */
const LOGO_URL = "/biodeal-animal-health-logo.png";

/**
 * Logo wrapper — preserves aspect ratio via object-contain, places the
 * supplied artwork inside a cream/white rounded card with a thin green
 * outline so the mark reads cleanly on both light AND dark surfaces.
 * No recolouring, no stretching, no cropping.
 *
 * Sizes (mobile → xl):
 *   sm  → 48 px (mobile header)
 *   md  → 64 px (desktop header)
 *   lg  → 96 px (footer, hero brand stamp)
 *   xl  → 128 px (oversized stamps)
 */
export default function BiodealLogo({ size = "md", showWordmark = false, className = "" }) {
  const sizes = {
    sm: "h-12 w-12",
    md: "h-16 w-16",
    lg: "h-24 w-24",
    xl: "h-32 w-32",
  };
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="bah-logo">
      <div
        className={`relative ${sizes[size]} rounded-lg overflow-hidden bg-white ring-2 ring-bah-green/50 flex items-center justify-center shadow-md`}
      >
        <img
          src={LOGO_URL}
          alt="Biodeal Animal Health — Believe in Better"
          className="w-full h-full object-contain"
          loading="eager"
        />
      </div>
      {showWordmark && (
        <div className="leading-tight">
          <div className="font-display text-bah-green text-xl font-semibold tracking-tight">
            Biodeal
          </div>
          <div className="font-sans text-bah-mute text-[11px] uppercase tracking-[0.18em]">
            Animal Health
          </div>
        </div>
      )}
    </div>
  );
}

export { LOGO_URL as BAH_LOGO_URL };
